import { render, staticRenderFns } from "./basic-related-tip.vue?vue&type=template&id=cfeccc70&scoped=true"
import script from "./basic-related-tip.vue?vue&type=script&lang=js"
export * from "./basic-related-tip.vue?vue&type=script&lang=js"
import style0 from "./basic-related-tip.vue?vue&type=style&index=0&id=cfeccc70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfeccc70",
  null
  
)

export default component.exports